// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","RowLinked":"RowLinked_ixWE2","previewDiv":"previewDiv_pWn7n","mobileSmall":"mobileSmall_AXZ0D"};